export default "__VITE_ASSET__09073a58__"